import type { ConceptDef } from '../types';

export const sequenceStoryCards: ConceptDef = {
  kind: 'sequenceTap',
  id: 'sequence-story-cards',
  label: 'Sequence Story Cards',
  category: 'Sequencing',
  description: 'Tap the cards in story order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Plant growing.', items: ['🌱 seed', '🌿 sprout', '🌳 tree'] },
      { label: 'Egg to butterfly.', items: ['🥚 egg', '🐛 caterpillar', '🦋 butterfly'] },
      { label: 'Cooking an egg.', items: ['🥚 egg', '🍳 pan', '🍽 plate'] },
    ],
  },
};
